import React from 'react';
import { Helmet } from 'react-helmet';
import { Dashboard } from 'layouts/Dashboard';
import { Contacts } from 'components';

const ContactsPage = () => {
  return (
    <>
      <Helmet>
        <title>Contacts</title>
      </Helmet>

      <Dashboard>
        <Contacts />
      </Dashboard>
    </>
  );
};

export default ContactsPage;
